import update from 'immutability-helper';
import {
	RECEIVE_WORKS,
	SET_WORK_DIMENSIONS
} from 'actions/WorksActions';
import {
	LOCATION_CHANGE,
	GO_TO
} from 'actions/NavActions';
import {INDEX_SEARCH_KEYS} from 'constants';
import {
	getImageSrc,
	idFromPath
} from 'utils/paths';
import {preloadWork} from 'utils/preloader';
import {worksSortTest} from 'utils/sort';


export function worksReducer(state={
	id: "",
	all: [],
	lookup: {},
	work: null
}, action){

	switch (action.type){

		case GO_TO: {
			let {lookup, all} = state;
			return {
				...state,
				id: action.id,
				work: all[lookup[action.id]]
			};
		}

		case RECEIVE_WORKS: {
			let lookup = {};
			let works = action.works.slice();
			works.forEach((w, idx) => {
				lookup[w.id] = idx;
			});
			
			let upd = {
				"lookup": {$set: lookup},
				"all": {$set: works},
			};

			if (state.id){
				upd.work = {$set: works[lookup[state.id]]}
			}
/*			try{
				if (!PRODUCTION){
					worksSortTest(works);
				}
			}
			catch(e){

			}*/

			return update(state, upd);
		}

		case LOCATION_CHANGE: {
			let {pathname} = action.payload;
			let id = idFromPath(action.payload.pathname);
			// preload next image
			let idx = state.lookup[id];
			let next = state.all[idx];
			if (idx >= 0 && next){
				preloadWork(
					state.all[idx + 1]
				);
			}
			return {
				...state,
				id,
				work: next
			};
		}

	   case SET_WORK_DIMENSIONS: {
           if (action.id && action.dimensions){
				let {width, height} = action.dimensions;
				let workIdx = state.lookup[action.id];
				if (workIdx >= 0){
				   return update(state, {
				   		all: {
				   			[workIdx]: {
				               aspect: {$set: width / height}
				           }
				       }
				   });
				}
           }
           return state;
       }

		default:
			return state;

	}
}
export default worksReducer;